import React from "react";
import BackgroundImage from 'gatsby-background-image'
import { graphql, useStaticQuery } from 'gatsby';
import withStyles from "@material-ui/core/styles/withStyles";

function WindmillMountain({...props}) {
  const {
    className,
    imageUrl,
    children,
    style
  } = props;
  const data = useStaticQuery(
    graphql`
      query {
        desktop: file(relativePath: { eq: "windmill-mountain.jpg" }) {
          childImageSharp {
            fluid(quality: 50, maxWidth: 960) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  );

  // Set ImageData.
  const imageData = data.desktop.childImageSharp.fluid;

  return (
    <BackgroundImage 
    Tag="div"
    role="img"
    aria-label="Electric windmills dotting a snowy mountain top."
    className={className}
    fluid={imageData}
    style={style}
    >
      {children}
    </BackgroundImage>
  )
};

const styles = {
  width: "100%",
  backgroundPosition: "bottom center",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover"
};

export default withStyles(styles)(WindmillMountain);